import { comboboxAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { base, variants } from '../common/ComboboxAndSelect.common';
import * as inputStyle from '../common/InputAndTextarea.common';

const comboboxSlotRecipe = defineSlotRecipe({
  className: 'combobox',
  slots: comboboxAnatomy.keys(),
  base: {
    control: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
    },
    input: {
      ...inputStyle.base,
      ...inputStyle.singleLineInputOverrides,
      height: 'var(--input-height)',
      textOverflow: 'ellipsis',
    },
    ...base,
    indicatorGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: '8',
      position: 'absolute',
      right: '16',
      top: '50%',
      transform: 'translateY(-50%)',
    },
    trigger: {
      cursor: 'pointer',
      _readOnly: {
        cursor: 'default',
      },
    },
  },
  variants: {
    size: {
      md: {
        input: {
          ...inputStyle.variants.size.md,
          ...inputStyle.singleLineInputOverrides,
          paddingInlineEnd: '96',
        },
        ...variants.size.md,
      },
      lg: {
        input: {
          ...inputStyle.variants.size.lg,
          ...inputStyle.singleLineInputOverrides,
          paddingInlineEnd: '96',
        },
        ...variants.size.lg,
      },
    },
    hasStatusIcon: {
      true: {
        input: {
          paddingInlineEnd: '128',
        },
      },
      false: {},
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

export default comboboxSlotRecipe;
